export const GET_ALL_DAYS='GET_ALL_DAYS'
export const SAVE_REGULARIZATION='SAVE_REGULARIZATION'
export const GET_REGULARIZATION_DETAILS='GET_REGULARIZATION_DETAILS'
export const SAVE_NOT_AT_SITE_ATTENDANCE='SAVE_NOT_AT_SITE_ATTENDANCE'
export const GET_ATTENDANCE_DETAILS='GET_ATTENDANCE_DETAILS'
export const MARK_CHECK_OUT='MARK_CHECK_OUT'
export const REGULARIZE_ATTENDANCE='REGULARIZE_ATTENDANCE'
export const GET_REGULARIZATION_FILTER='GET_REGULARIZATION_FILTER'
export const ATTENDANCE_DATA = 'ATTENDANCE_DATA'
export const MONTHS_FILTER = 'MONTHS_FILTER'